const SAVED_SELECTED_COMPANY_ID_KEY = 'SAVED_SELECTED_COMPANY_ID'

type SavedCompany = {
  userId: number
  companyId: number
}

export const getSavedSelectedCompanyId = ({ userId }: { userId: number }) => {
  const savedCompany = localStorage.getItem(SAVED_SELECTED_COMPANY_ID_KEY)
  if (savedCompany === null) {
    return null
  }
  const parsedSavedCompanys = JSON.parse(savedCompany) as SavedCompany
  return parsedSavedCompanys.userId === userId
    ? parsedSavedCompanys.companyId
    : null
}

export const setSavedSelectedCompanyId = ({
  userId,
  companyId,
}: SavedCompany) => {
  localStorage.setItem(
    SAVED_SELECTED_COMPANY_ID_KEY,
    JSON.stringify({
      userId,
      companyId,
    })
  )
}

export const removeSavedSelectedCompanyId = () => {
  localStorage.removeItem(SAVED_SELECTED_COMPANY_ID_KEY)
}
